/* __next_internal_client_entry_do_not_use__ SearchProductTileBrandLink auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { handleGenerateBrandUrl } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
import { ProductTileContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { useGetProductTileClickImpressions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { MarketplaceProductBrandLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProductBrandLink";
import { useSettingBrandLinkHoverThreshold } from "@faire/retailer-visitor-shared/settings/getSettingBrandLinkHoverTheshold";
import { getSettingRscLibp } from "@faire/retailer-visitor-shared/settings/getSettingRscLibp";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackSeoSearchProductListBrandLinkRefsClick } from "@faire/web-api--source/events/seo/click/searchProductListBrandLinkRefs";
import kebabCase from "lodash/kebabCase";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import React, { useCallback, useContext, useMemo, useRef } from "react";
/**
 * Used for brand info on search page rsc version.
 * Non rsc link: use MarketplaceProductBrandLinkBase instead
 */ export var SearchProductTileBrandLink = function(param) {
    var data = param.data, children = param.children;
    var PREFETCH_DELAY_MS = useSettingBrandLinkHoverThreshold();
    var timeoutRef = useRef(undefined);
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var isRSCBrandPage = getSettingRscLibp();
    var trackingParams = data.trackingParams;
    var _useContext = useContext(ProductTileContext), contextBrandToken = _useContext.brandToken;
    var generateBrandUrl = useMemo(function() {
        var _data_brandToken;
        return handleGenerateBrandUrl(data.productSearchString, {
            productToken: trackingParams.token,
            brandToken: (_data_brandToken = data.brandToken) !== null && _data_brandToken !== void 0 ? _data_brandToken : contextBrandToken,
            impressionId: trackingParams.impressionId
        });
    }, [
        data.productSearchString,
        trackingParams.token,
        trackingParams.impressionId,
        data.brandToken,
        contextBrandToken
    ]);
    var onBrandClickSearchPage = useOnBrandClickSearchPage(trackingParams, data.brandToken, data.productSearchString);
    var onBrandClick = useCallback(function(ev) {
        onBrandClickSearchPage.onBrandClick(ev);
        clearTimeout(timeoutRef.current);
    }, [
        onBrandClickSearchPage
    ]);
    var brandUrl = generateBrandUrl();
    var onBrandLinkFocus = useCallback(function() {
        timeoutRef.current = setTimeout(function() {
            if (isRSCBrandPage) {
                nextPrefetch(brandUrl, {
                    kind: PrefetchKind.FULL
                });
            }
        }, PREFETCH_DELAY_MS);
    }, [
        brandUrl,
        nextPrefetch,
        isRSCBrandPage,
        PREFETCH_DELAY_MS
    ]);
    var onBrandLinkBlur = useCallback(function() {
        clearTimeout(timeoutRef.current);
    }, []);
    return /*#__PURE__*/ _jsx(MarketplaceProductBrandLink, {
        token: trackingParams.token,
        onClick: function(ev) {
            onBrandClick === null || onBrandClick === void 0 ? void 0 : onBrandClick(ev);
        },
        onMouseEnter: function() {
            onBrandLinkFocus === null || onBrandLinkFocus === void 0 ? void 0 : onBrandLinkFocus();
        },
        onMouseLeave: function() {
            onBrandLinkBlur === null || onBrandLinkBlur === void 0 ? void 0 : onBrandLinkBlur();
        },
        onFocus: function() {
            onBrandLinkFocus === null || onBrandLinkFocus === void 0 ? void 0 : onBrandLinkFocus();
        },
        onBlur: function() {
            onBrandLinkBlur === null || onBrandLinkBlur === void 0 ? void 0 : onBrandLinkBlur();
        },
        onTouchStart: function() {
            onBrandLinkFocus === null || onBrandLinkFocus === void 0 ? void 0 : onBrandLinkFocus();
        },
        "data-test-id": "marketplace-product-brand-link",
        to: brandUrl,
        children: children
    });
};
var useOnBrandClickSearchPage = function(params, brandToken, productSearchString) {
    var recordBrandNameClickEvent = useGetProductTileClickImpressions(params).recordBrandNameClickEvent;
    return {
        onBrandClick: function(event) {
            recordBrandNameClickEvent();
            var productToken = params.token;
            if (!productSearchString || !productToken || !brandToken) {
                return;
            }
            trackEvent("/search-click/".concat(kebabCase(productSearchString), "/product/").concat(productToken, "/brand/").concat(brandToken));
            trackSeoSearchProductListBrandLinkRefsClick(brandToken !== null && brandToken !== void 0 ? brandToken : "", productSearchString);
            event.stopPropagation();
        }
    };
};
